/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createTodo = /* GraphQL */ `
  mutation CreateTodo(
    $input: CreateTodoInput!
    $condition: ModelTodoConditionInput
  ) {
    createTodo(input: $input, condition: $condition) {
      id
      authorID
      author {
        id
        first
        last
        email
        phone
        birthday
        department
        director
        joinDate
        unitPrice
        enabled
        role
        corporateIDs
        remarks
        widgets {
          name
          enabled
          __typename
        }
        employmentType
        paidRemain
        paidHoursUsed
        dailyWorktime
        createdAt
        updatedAt
        __typename
      }
      title
      description
      start
      end
      fillColor
      textColor
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTodo = /* GraphQL */ `
  mutation UpdateTodo(
    $input: UpdateTodoInput!
    $condition: ModelTodoConditionInput
  ) {
    updateTodo(input: $input, condition: $condition) {
      id
      authorID
      author {
        id
        first
        last
        email
        phone
        birthday
        department
        director
        joinDate
        unitPrice
        enabled
        role
        corporateIDs
        remarks
        widgets {
          name
          enabled
          __typename
        }
        employmentType
        paidRemain
        paidHoursUsed
        dailyWorktime
        createdAt
        updatedAt
        __typename
      }
      title
      description
      start
      end
      fillColor
      textColor
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTodo = /* GraphQL */ `
  mutation DeleteTodo(
    $input: DeleteTodoInput!
    $condition: ModelTodoConditionInput
  ) {
    deleteTodo(input: $input, condition: $condition) {
      id
      authorID
      author {
        id
        first
        last
        email
        phone
        birthday
        department
        director
        joinDate
        unitPrice
        enabled
        role
        corporateIDs
        remarks
        widgets {
          name
          enabled
          __typename
        }
        employmentType
        paidRemain
        paidHoursUsed
        dailyWorktime
        createdAt
        updatedAt
        __typename
      }
      title
      description
      start
      end
      fillColor
      textColor
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAppOption = /* GraphQL */ `
  mutation CreateAppOption(
    $input: CreateAppOptionInput!
    $condition: ModelAppOptionConditionInput
  ) {
    createAppOption(input: $input, condition: $condition) {
      name
      tag
      value
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateAppOption = /* GraphQL */ `
  mutation UpdateAppOption(
    $input: UpdateAppOptionInput!
    $condition: ModelAppOptionConditionInput
  ) {
    updateAppOption(input: $input, condition: $condition) {
      name
      tag
      value
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteAppOption = /* GraphQL */ `
  mutation DeleteAppOption(
    $input: DeleteAppOptionInput!
    $condition: ModelAppOptionConditionInput
  ) {
    deleteAppOption(input: $input, condition: $condition) {
      name
      tag
      value
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSequence = /* GraphQL */ `
  mutation CreateSequence(
    $input: CreateSequenceInput!
    $condition: ModelSequenceConditionInput
  ) {
    createSequence(input: $input, condition: $condition) {
      name
      tag
      count
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSequence = /* GraphQL */ `
  mutation UpdateSequence(
    $input: UpdateSequenceInput!
    $condition: ModelSequenceConditionInput
  ) {
    updateSequence(input: $input, condition: $condition) {
      name
      tag
      count
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSequence = /* GraphQL */ `
  mutation DeleteSequence(
    $input: DeleteSequenceInput!
    $condition: ModelSequenceConditionInput
  ) {
    deleteSequence(input: $input, condition: $condition) {
      name
      tag
      count
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      first
      last
      email
      phone
      birthday
      department
      director
      joinDate
      unitPrice
      enabled
      role
      corporateIDs
      remarks
      widgets {
        name
        enabled
        __typename
      }
      employmentType
      paidRemain
      paidHoursUsed
      dailyWorktime
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      first
      last
      email
      phone
      birthday
      department
      director
      joinDate
      unitPrice
      enabled
      role
      corporateIDs
      remarks
      widgets {
        name
        enabled
        __typename
      }
      employmentType
      paidRemain
      paidHoursUsed
      dailyWorktime
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      first
      last
      email
      phone
      birthday
      department
      director
      joinDate
      unitPrice
      enabled
      role
      corporateIDs
      remarks
      widgets {
        name
        enabled
        __typename
      }
      employmentType
      paidRemain
      paidHoursUsed
      dailyWorktime
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createRole = /* GraphQL */ `
  mutation CreateRole(
    $input: CreateRoleInput!
    $condition: ModelRoleConditionInput
  ) {
    createRole(input: $input, condition: $condition) {
      id
      name
      functions {
        name
        enabled
        permission
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateRole = /* GraphQL */ `
  mutation UpdateRole(
    $input: UpdateRoleInput!
    $condition: ModelRoleConditionInput
  ) {
    updateRole(input: $input, condition: $condition) {
      id
      name
      functions {
        name
        enabled
        permission
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteRole = /* GraphQL */ `
  mutation DeleteRole(
    $input: DeleteRoleInput!
    $condition: ModelRoleConditionInput
  ) {
    deleteRole(input: $input, condition: $condition) {
      id
      name
      functions {
        name
        enabled
        permission
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCustomer = /* GraphQL */ `
  mutation CreateCustomer(
    $input: CreateCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    createCustomer(input: $input, condition: $condition) {
      id
      email
      passwd
      serial
      name
      office
      post
      pref
      address
      build
      tel
      fax
      url
      agencyID
      closing
      payment
      rate
      charge
      salesID
      color
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCustomer = /* GraphQL */ `
  mutation UpdateCustomer(
    $input: UpdateCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    updateCustomer(input: $input, condition: $condition) {
      id
      email
      passwd
      serial
      name
      office
      post
      pref
      address
      build
      tel
      fax
      url
      agencyID
      closing
      payment
      rate
      charge
      salesID
      color
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCustomer = /* GraphQL */ `
  mutation DeleteCustomer(
    $input: DeleteCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    deleteCustomer(input: $input, condition: $condition) {
      id
      email
      passwd
      serial
      name
      office
      post
      pref
      address
      build
      tel
      fax
      url
      agencyID
      closing
      payment
      rate
      charge
      salesID
      color
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCorporate = /* GraphQL */ `
  mutation CreateCorporate(
    $input: CreateCorporateInput!
    $condition: ModelCorporateConditionInput
  ) {
    createCorporate(input: $input, condition: $condition) {
      id
      name
      furigana
      post
      pref
      address
      build
      tel
      fax
      logo
      sign
      bank {
        items {
          id
          corporateID
          corporate {
            id
            name
            furigana
            post
            pref
            address
            build
            tel
            fax
            logo
            sign
            slipFormat
            startMonth
            invoice
            createdAt
            updatedAt
            __typename
          }
          name
          store
          type
          no
          owner
          sort
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      office {
        items {
          id
          corporateID
          corporate {
            id
            name
            furigana
            post
            pref
            address
            build
            tel
            fax
            logo
            sign
            slipFormat
            startMonth
            invoice
            createdAt
            updatedAt
            __typename
          }
          name
          post
          pref
          address
          build
          tel
          fax
          sort
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      slipFormat
      startMonth
      invoice
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCorporate = /* GraphQL */ `
  mutation UpdateCorporate(
    $input: UpdateCorporateInput!
    $condition: ModelCorporateConditionInput
  ) {
    updateCorporate(input: $input, condition: $condition) {
      id
      name
      furigana
      post
      pref
      address
      build
      tel
      fax
      logo
      sign
      bank {
        items {
          id
          corporateID
          corporate {
            id
            name
            furigana
            post
            pref
            address
            build
            tel
            fax
            logo
            sign
            slipFormat
            startMonth
            invoice
            createdAt
            updatedAt
            __typename
          }
          name
          store
          type
          no
          owner
          sort
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      office {
        items {
          id
          corporateID
          corporate {
            id
            name
            furigana
            post
            pref
            address
            build
            tel
            fax
            logo
            sign
            slipFormat
            startMonth
            invoice
            createdAt
            updatedAt
            __typename
          }
          name
          post
          pref
          address
          build
          tel
          fax
          sort
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      slipFormat
      startMonth
      invoice
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCorporate = /* GraphQL */ `
  mutation DeleteCorporate(
    $input: DeleteCorporateInput!
    $condition: ModelCorporateConditionInput
  ) {
    deleteCorporate(input: $input, condition: $condition) {
      id
      name
      furigana
      post
      pref
      address
      build
      tel
      fax
      logo
      sign
      bank {
        items {
          id
          corporateID
          corporate {
            id
            name
            furigana
            post
            pref
            address
            build
            tel
            fax
            logo
            sign
            slipFormat
            startMonth
            invoice
            createdAt
            updatedAt
            __typename
          }
          name
          store
          type
          no
          owner
          sort
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      office {
        items {
          id
          corporateID
          corporate {
            id
            name
            furigana
            post
            pref
            address
            build
            tel
            fax
            logo
            sign
            slipFormat
            startMonth
            invoice
            createdAt
            updatedAt
            __typename
          }
          name
          post
          pref
          address
          build
          tel
          fax
          sort
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      slipFormat
      startMonth
      invoice
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createOffice = /* GraphQL */ `
  mutation CreateOffice(
    $input: CreateOfficeInput!
    $condition: ModelOfficeConditionInput
  ) {
    createOffice(input: $input, condition: $condition) {
      id
      corporateID
      corporate {
        id
        name
        furigana
        post
        pref
        address
        build
        tel
        fax
        logo
        sign
        bank {
          items {
            id
            corporateID
            name
            store
            type
            no
            owner
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        office {
          items {
            id
            corporateID
            name
            post
            pref
            address
            build
            tel
            fax
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        slipFormat
        startMonth
        invoice
        createdAt
        updatedAt
        __typename
      }
      name
      post
      pref
      address
      build
      tel
      fax
      sort
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateOffice = /* GraphQL */ `
  mutation UpdateOffice(
    $input: UpdateOfficeInput!
    $condition: ModelOfficeConditionInput
  ) {
    updateOffice(input: $input, condition: $condition) {
      id
      corporateID
      corporate {
        id
        name
        furigana
        post
        pref
        address
        build
        tel
        fax
        logo
        sign
        bank {
          items {
            id
            corporateID
            name
            store
            type
            no
            owner
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        office {
          items {
            id
            corporateID
            name
            post
            pref
            address
            build
            tel
            fax
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        slipFormat
        startMonth
        invoice
        createdAt
        updatedAt
        __typename
      }
      name
      post
      pref
      address
      build
      tel
      fax
      sort
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteOffice = /* GraphQL */ `
  mutation DeleteOffice(
    $input: DeleteOfficeInput!
    $condition: ModelOfficeConditionInput
  ) {
    deleteOffice(input: $input, condition: $condition) {
      id
      corporateID
      corporate {
        id
        name
        furigana
        post
        pref
        address
        build
        tel
        fax
        logo
        sign
        bank {
          items {
            id
            corporateID
            name
            store
            type
            no
            owner
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        office {
          items {
            id
            corporateID
            name
            post
            pref
            address
            build
            tel
            fax
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        slipFormat
        startMonth
        invoice
        createdAt
        updatedAt
        __typename
      }
      name
      post
      pref
      address
      build
      tel
      fax
      sort
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createBank = /* GraphQL */ `
  mutation CreateBank(
    $input: CreateBankInput!
    $condition: ModelBankConditionInput
  ) {
    createBank(input: $input, condition: $condition) {
      id
      corporateID
      corporate {
        id
        name
        furigana
        post
        pref
        address
        build
        tel
        fax
        logo
        sign
        bank {
          items {
            id
            corporateID
            name
            store
            type
            no
            owner
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        office {
          items {
            id
            corporateID
            name
            post
            pref
            address
            build
            tel
            fax
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        slipFormat
        startMonth
        invoice
        createdAt
        updatedAt
        __typename
      }
      name
      store
      type
      no
      owner
      sort
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateBank = /* GraphQL */ `
  mutation UpdateBank(
    $input: UpdateBankInput!
    $condition: ModelBankConditionInput
  ) {
    updateBank(input: $input, condition: $condition) {
      id
      corporateID
      corporate {
        id
        name
        furigana
        post
        pref
        address
        build
        tel
        fax
        logo
        sign
        bank {
          items {
            id
            corporateID
            name
            store
            type
            no
            owner
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        office {
          items {
            id
            corporateID
            name
            post
            pref
            address
            build
            tel
            fax
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        slipFormat
        startMonth
        invoice
        createdAt
        updatedAt
        __typename
      }
      name
      store
      type
      no
      owner
      sort
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteBank = /* GraphQL */ `
  mutation DeleteBank(
    $input: DeleteBankInput!
    $condition: ModelBankConditionInput
  ) {
    deleteBank(input: $input, condition: $condition) {
      id
      corporateID
      corporate {
        id
        name
        furigana
        post
        pref
        address
        build
        tel
        fax
        logo
        sign
        bank {
          items {
            id
            corporateID
            name
            store
            type
            no
            owner
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        office {
          items {
            id
            corporateID
            name
            post
            pref
            address
            build
            tel
            fax
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        slipFormat
        startMonth
        invoice
        createdAt
        updatedAt
        __typename
      }
      name
      store
      type
      no
      owner
      sort
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createProject = /* GraphQL */ `
  mutation CreateProject(
    $input: CreateProjectInput!
    $condition: ModelProjectConditionInput
  ) {
    createProject(input: $input, condition: $condition) {
      id
      code
      name
      corporateID
      customerID
      customer {
        id
        email
        passwd
        serial
        name
        office
        post
        pref
        address
        build
        tel
        fax
        url
        agencyID
        closing
        payment
        rate
        charge
        salesID
        color
        createdAt
        updatedAt
        __typename
      }
      deliveryDate
      documents {
        items {
          id
          projectID
          project {
            id
            code
            name
            corporateID
            customerID
            deliveryDate
            createdAt
            updatedAt
            __typename
          }
          name
          file
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      processes {
        items {
          id
          projectID
          project {
            id
            code
            name
            corporateID
            customerID
            deliveryDate
            createdAt
            updatedAt
            __typename
          }
          name
          parentID
          dependentOn
          charge
          start
          end
          progress
          color
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateProject = /* GraphQL */ `
  mutation UpdateProject(
    $input: UpdateProjectInput!
    $condition: ModelProjectConditionInput
  ) {
    updateProject(input: $input, condition: $condition) {
      id
      code
      name
      corporateID
      customerID
      customer {
        id
        email
        passwd
        serial
        name
        office
        post
        pref
        address
        build
        tel
        fax
        url
        agencyID
        closing
        payment
        rate
        charge
        salesID
        color
        createdAt
        updatedAt
        __typename
      }
      deliveryDate
      documents {
        items {
          id
          projectID
          project {
            id
            code
            name
            corporateID
            customerID
            deliveryDate
            createdAt
            updatedAt
            __typename
          }
          name
          file
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      processes {
        items {
          id
          projectID
          project {
            id
            code
            name
            corporateID
            customerID
            deliveryDate
            createdAt
            updatedAt
            __typename
          }
          name
          parentID
          dependentOn
          charge
          start
          end
          progress
          color
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteProject = /* GraphQL */ `
  mutation DeleteProject(
    $input: DeleteProjectInput!
    $condition: ModelProjectConditionInput
  ) {
    deleteProject(input: $input, condition: $condition) {
      id
      code
      name
      corporateID
      customerID
      customer {
        id
        email
        passwd
        serial
        name
        office
        post
        pref
        address
        build
        tel
        fax
        url
        agencyID
        closing
        payment
        rate
        charge
        salesID
        color
        createdAt
        updatedAt
        __typename
      }
      deliveryDate
      documents {
        items {
          id
          projectID
          project {
            id
            code
            name
            corporateID
            customerID
            deliveryDate
            createdAt
            updatedAt
            __typename
          }
          name
          file
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      processes {
        items {
          id
          projectID
          project {
            id
            code
            name
            corporateID
            customerID
            deliveryDate
            createdAt
            updatedAt
            __typename
          }
          name
          parentID
          dependentOn
          charge
          start
          end
          progress
          color
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDocument = /* GraphQL */ `
  mutation CreateDocument(
    $input: CreateDocumentInput!
    $condition: ModelDocumentConditionInput
  ) {
    createDocument(input: $input, condition: $condition) {
      id
      projectID
      project {
        id
        code
        name
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        deliveryDate
        documents {
          items {
            id
            projectID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        processes {
          items {
            id
            projectID
            name
            parentID
            dependentOn
            charge
            start
            end
            progress
            color
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      name
      file
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDocument = /* GraphQL */ `
  mutation UpdateDocument(
    $input: UpdateDocumentInput!
    $condition: ModelDocumentConditionInput
  ) {
    updateDocument(input: $input, condition: $condition) {
      id
      projectID
      project {
        id
        code
        name
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        deliveryDate
        documents {
          items {
            id
            projectID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        processes {
          items {
            id
            projectID
            name
            parentID
            dependentOn
            charge
            start
            end
            progress
            color
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      name
      file
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDocument = /* GraphQL */ `
  mutation DeleteDocument(
    $input: DeleteDocumentInput!
    $condition: ModelDocumentConditionInput
  ) {
    deleteDocument(input: $input, condition: $condition) {
      id
      projectID
      project {
        id
        code
        name
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        deliveryDate
        documents {
          items {
            id
            projectID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        processes {
          items {
            id
            projectID
            name
            parentID
            dependentOn
            charge
            start
            end
            progress
            color
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      name
      file
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDialy = /* GraphQL */ `
  mutation CreateDialy(
    $input: CreateDialyInput!
    $condition: ModelDialyConditionInput
  ) {
    createDialy(input: $input, condition: $condition) {
      id
      userID
      user {
        id
        first
        last
        email
        phone
        birthday
        department
        director
        joinDate
        unitPrice
        enabled
        role
        corporateIDs
        remarks
        widgets {
          name
          enabled
          __typename
        }
        employmentType
        paidRemain
        paidHoursUsed
        dailyWorktime
        createdAt
        updatedAt
        __typename
      }
      start
      works {
        items {
          id
          dialyID
          dialy {
            id
            userID
            start
            probate
            unlock
            totalTime
            overTime
            midnightTime
            holidayTime
            holidayMignightTime
            createdAt
            updatedAt
            __typename
          }
          projectID
          project {
            id
            code
            name
            corporateID
            customerID
            deliveryDate
            createdAt
            updatedAt
            __typename
          }
          worktypeID
          workType {
            id
            code
            name
            createdAt
            updatedAt
            __typename
          }
          start
          end
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      probate
      unlock
      totalTime
      overTime
      midnightTime
      holidayTime
      holidayMignightTime
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDialy = /* GraphQL */ `
  mutation UpdateDialy(
    $input: UpdateDialyInput!
    $condition: ModelDialyConditionInput
  ) {
    updateDialy(input: $input, condition: $condition) {
      id
      userID
      user {
        id
        first
        last
        email
        phone
        birthday
        department
        director
        joinDate
        unitPrice
        enabled
        role
        corporateIDs
        remarks
        widgets {
          name
          enabled
          __typename
        }
        employmentType
        paidRemain
        paidHoursUsed
        dailyWorktime
        createdAt
        updatedAt
        __typename
      }
      start
      works {
        items {
          id
          dialyID
          dialy {
            id
            userID
            start
            probate
            unlock
            totalTime
            overTime
            midnightTime
            holidayTime
            holidayMignightTime
            createdAt
            updatedAt
            __typename
          }
          projectID
          project {
            id
            code
            name
            corporateID
            customerID
            deliveryDate
            createdAt
            updatedAt
            __typename
          }
          worktypeID
          workType {
            id
            code
            name
            createdAt
            updatedAt
            __typename
          }
          start
          end
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      probate
      unlock
      totalTime
      overTime
      midnightTime
      holidayTime
      holidayMignightTime
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDialy = /* GraphQL */ `
  mutation DeleteDialy(
    $input: DeleteDialyInput!
    $condition: ModelDialyConditionInput
  ) {
    deleteDialy(input: $input, condition: $condition) {
      id
      userID
      user {
        id
        first
        last
        email
        phone
        birthday
        department
        director
        joinDate
        unitPrice
        enabled
        role
        corporateIDs
        remarks
        widgets {
          name
          enabled
          __typename
        }
        employmentType
        paidRemain
        paidHoursUsed
        dailyWorktime
        createdAt
        updatedAt
        __typename
      }
      start
      works {
        items {
          id
          dialyID
          dialy {
            id
            userID
            start
            probate
            unlock
            totalTime
            overTime
            midnightTime
            holidayTime
            holidayMignightTime
            createdAt
            updatedAt
            __typename
          }
          projectID
          project {
            id
            code
            name
            corporateID
            customerID
            deliveryDate
            createdAt
            updatedAt
            __typename
          }
          worktypeID
          workType {
            id
            code
            name
            createdAt
            updatedAt
            __typename
          }
          start
          end
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      probate
      unlock
      totalTime
      overTime
      midnightTime
      holidayTime
      holidayMignightTime
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createWork = /* GraphQL */ `
  mutation CreateWork(
    $input: CreateWorkInput!
    $condition: ModelWorkConditionInput
  ) {
    createWork(input: $input, condition: $condition) {
      id
      dialyID
      dialy {
        id
        userID
        user {
          id
          first
          last
          email
          phone
          birthday
          department
          director
          joinDate
          unitPrice
          enabled
          role
          corporateIDs
          remarks
          widgets {
            name
            enabled
            __typename
          }
          employmentType
          paidRemain
          paidHoursUsed
          dailyWorktime
          createdAt
          updatedAt
          __typename
        }
        start
        works {
          items {
            id
            dialyID
            projectID
            worktypeID
            start
            end
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        probate
        unlock
        totalTime
        overTime
        midnightTime
        holidayTime
        holidayMignightTime
        createdAt
        updatedAt
        __typename
      }
      projectID
      project {
        id
        code
        name
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        deliveryDate
        documents {
          items {
            id
            projectID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        processes {
          items {
            id
            projectID
            name
            parentID
            dependentOn
            charge
            start
            end
            progress
            color
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      worktypeID
      workType {
        id
        code
        name
        createdAt
        updatedAt
        __typename
      }
      start
      end
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateWork = /* GraphQL */ `
  mutation UpdateWork(
    $input: UpdateWorkInput!
    $condition: ModelWorkConditionInput
  ) {
    updateWork(input: $input, condition: $condition) {
      id
      dialyID
      dialy {
        id
        userID
        user {
          id
          first
          last
          email
          phone
          birthday
          department
          director
          joinDate
          unitPrice
          enabled
          role
          corporateIDs
          remarks
          widgets {
            name
            enabled
            __typename
          }
          employmentType
          paidRemain
          paidHoursUsed
          dailyWorktime
          createdAt
          updatedAt
          __typename
        }
        start
        works {
          items {
            id
            dialyID
            projectID
            worktypeID
            start
            end
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        probate
        unlock
        totalTime
        overTime
        midnightTime
        holidayTime
        holidayMignightTime
        createdAt
        updatedAt
        __typename
      }
      projectID
      project {
        id
        code
        name
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        deliveryDate
        documents {
          items {
            id
            projectID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        processes {
          items {
            id
            projectID
            name
            parentID
            dependentOn
            charge
            start
            end
            progress
            color
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      worktypeID
      workType {
        id
        code
        name
        createdAt
        updatedAt
        __typename
      }
      start
      end
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteWork = /* GraphQL */ `
  mutation DeleteWork(
    $input: DeleteWorkInput!
    $condition: ModelWorkConditionInput
  ) {
    deleteWork(input: $input, condition: $condition) {
      id
      dialyID
      dialy {
        id
        userID
        user {
          id
          first
          last
          email
          phone
          birthday
          department
          director
          joinDate
          unitPrice
          enabled
          role
          corporateIDs
          remarks
          widgets {
            name
            enabled
            __typename
          }
          employmentType
          paidRemain
          paidHoursUsed
          dailyWorktime
          createdAt
          updatedAt
          __typename
        }
        start
        works {
          items {
            id
            dialyID
            projectID
            worktypeID
            start
            end
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        probate
        unlock
        totalTime
        overTime
        midnightTime
        holidayTime
        holidayMignightTime
        createdAt
        updatedAt
        __typename
      }
      projectID
      project {
        id
        code
        name
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        deliveryDate
        documents {
          items {
            id
            projectID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        processes {
          items {
            id
            projectID
            name
            parentID
            dependentOn
            charge
            start
            end
            progress
            color
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      worktypeID
      workType {
        id
        code
        name
        createdAt
        updatedAt
        __typename
      }
      start
      end
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createWorkType = /* GraphQL */ `
  mutation CreateWorkType(
    $input: CreateWorkTypeInput!
    $condition: ModelWorkTypeConditionInput
  ) {
    createWorkType(input: $input, condition: $condition) {
      id
      code
      name
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateWorkType = /* GraphQL */ `
  mutation UpdateWorkType(
    $input: UpdateWorkTypeInput!
    $condition: ModelWorkTypeConditionInput
  ) {
    updateWorkType(input: $input, condition: $condition) {
      id
      code
      name
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteWorkType = /* GraphQL */ `
  mutation DeleteWorkType(
    $input: DeleteWorkTypeInput!
    $condition: ModelWorkTypeConditionInput
  ) {
    deleteWorkType(input: $input, condition: $condition) {
      id
      code
      name
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createWorkTimeGroup = /* GraphQL */ `
  mutation CreateWorkTimeGroup(
    $input: CreateWorkTimeGroupInput!
    $condition: ModelWorkTimeGroupConditionInput
  ) {
    createWorkTimeGroup(input: $input, condition: $condition) {
      id
      start
      end
      workTimes {
        items {
          id
          groupID
          start
          end
          name
          type
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateWorkTimeGroup = /* GraphQL */ `
  mutation UpdateWorkTimeGroup(
    $input: UpdateWorkTimeGroupInput!
    $condition: ModelWorkTimeGroupConditionInput
  ) {
    updateWorkTimeGroup(input: $input, condition: $condition) {
      id
      start
      end
      workTimes {
        items {
          id
          groupID
          start
          end
          name
          type
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteWorkTimeGroup = /* GraphQL */ `
  mutation DeleteWorkTimeGroup(
    $input: DeleteWorkTimeGroupInput!
    $condition: ModelWorkTimeGroupConditionInput
  ) {
    deleteWorkTimeGroup(input: $input, condition: $condition) {
      id
      start
      end
      workTimes {
        items {
          id
          groupID
          start
          end
          name
          type
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createWorkTime = /* GraphQL */ `
  mutation CreateWorkTime(
    $input: CreateWorkTimeInput!
    $condition: ModelWorkTimeConditionInput
  ) {
    createWorkTime(input: $input, condition: $condition) {
      id
      groupID
      start
      end
      name
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateWorkTime = /* GraphQL */ `
  mutation UpdateWorkTime(
    $input: UpdateWorkTimeInput!
    $condition: ModelWorkTimeConditionInput
  ) {
    updateWorkTime(input: $input, condition: $condition) {
      id
      groupID
      start
      end
      name
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteWorkTime = /* GraphQL */ `
  mutation DeleteWorkTime(
    $input: DeleteWorkTimeInput!
    $condition: ModelWorkTimeConditionInput
  ) {
    deleteWorkTime(input: $input, condition: $condition) {
      id
      groupID
      start
      end
      name
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createEvent = /* GraphQL */ `
  mutation CreateEvent(
    $input: CreateEventInput!
    $condition: ModelEventConditionInput
  ) {
    createEvent(input: $input, condition: $condition) {
      id
      start
      end
      name
      type
      color
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateEvent = /* GraphQL */ `
  mutation UpdateEvent(
    $input: UpdateEventInput!
    $condition: ModelEventConditionInput
  ) {
    updateEvent(input: $input, condition: $condition) {
      id
      start
      end
      name
      type
      color
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteEvent = /* GraphQL */ `
  mutation DeleteEvent(
    $input: DeleteEventInput!
    $condition: ModelEventConditionInput
  ) {
    deleteEvent(input: $input, condition: $condition) {
      id
      start
      end
      name
      type
      color
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createProcess = /* GraphQL */ `
  mutation CreateProcess(
    $input: CreateProcessInput!
    $condition: ModelProcessConditionInput
  ) {
    createProcess(input: $input, condition: $condition) {
      id
      projectID
      project {
        id
        code
        name
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        deliveryDate
        documents {
          items {
            id
            projectID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        processes {
          items {
            id
            projectID
            name
            parentID
            dependentOn
            charge
            start
            end
            progress
            color
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      name
      parentID
      dependentOn
      charge
      start
      end
      progress
      color
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateProcess = /* GraphQL */ `
  mutation UpdateProcess(
    $input: UpdateProcessInput!
    $condition: ModelProcessConditionInput
  ) {
    updateProcess(input: $input, condition: $condition) {
      id
      projectID
      project {
        id
        code
        name
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        deliveryDate
        documents {
          items {
            id
            projectID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        processes {
          items {
            id
            projectID
            name
            parentID
            dependentOn
            charge
            start
            end
            progress
            color
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      name
      parentID
      dependentOn
      charge
      start
      end
      progress
      color
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteProcess = /* GraphQL */ `
  mutation DeleteProcess(
    $input: DeleteProcessInput!
    $condition: ModelProcessConditionInput
  ) {
    deleteProcess(input: $input, condition: $condition) {
      id
      projectID
      project {
        id
        code
        name
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        deliveryDate
        documents {
          items {
            id
            projectID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        processes {
          items {
            id
            projectID
            name
            parentID
            dependentOn
            charge
            start
            end
            progress
            color
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      name
      parentID
      dependentOn
      charge
      start
      end
      progress
      color
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createProduct = /* GraphQL */ `
  mutation CreateProduct(
    $input: CreateProductInput!
    $condition: ModelProductConditionInput
  ) {
    createProduct(input: $input, condition: $condition) {
      id
      category
      name
      mainTitle
      subTitle
      mainPic
      models {
        items {
          id
          productID
          product {
            id
            category
            name
            mainTitle
            subTitle
            mainPic
            publish
            createdAt
            updatedAt
            __typename
          }
          serial
          name
          code
          size
          color
          material
          value
          remark
          mainPic
          customerID
          remain
          inventory
          publish
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      files {
        items {
          id
          productID
          product {
            id
            category
            name
            mainTitle
            subTitle
            mainPic
            publish
            createdAt
            updatedAt
            __typename
          }
          name
          file
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      publish
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateProduct = /* GraphQL */ `
  mutation UpdateProduct(
    $input: UpdateProductInput!
    $condition: ModelProductConditionInput
  ) {
    updateProduct(input: $input, condition: $condition) {
      id
      category
      name
      mainTitle
      subTitle
      mainPic
      models {
        items {
          id
          productID
          product {
            id
            category
            name
            mainTitle
            subTitle
            mainPic
            publish
            createdAt
            updatedAt
            __typename
          }
          serial
          name
          code
          size
          color
          material
          value
          remark
          mainPic
          customerID
          remain
          inventory
          publish
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      files {
        items {
          id
          productID
          product {
            id
            category
            name
            mainTitle
            subTitle
            mainPic
            publish
            createdAt
            updatedAt
            __typename
          }
          name
          file
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      publish
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteProduct = /* GraphQL */ `
  mutation DeleteProduct(
    $input: DeleteProductInput!
    $condition: ModelProductConditionInput
  ) {
    deleteProduct(input: $input, condition: $condition) {
      id
      category
      name
      mainTitle
      subTitle
      mainPic
      models {
        items {
          id
          productID
          product {
            id
            category
            name
            mainTitle
            subTitle
            mainPic
            publish
            createdAt
            updatedAt
            __typename
          }
          serial
          name
          code
          size
          color
          material
          value
          remark
          mainPic
          customerID
          remain
          inventory
          publish
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      files {
        items {
          id
          productID
          product {
            id
            category
            name
            mainTitle
            subTitle
            mainPic
            publish
            createdAt
            updatedAt
            __typename
          }
          name
          file
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      publish
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createModel = /* GraphQL */ `
  mutation CreateModel(
    $input: CreateModelInput!
    $condition: ModelModelConditionInput
  ) {
    createModel(input: $input, condition: $condition) {
      id
      productID
      product {
        id
        category
        name
        mainTitle
        subTitle
        mainPic
        models {
          items {
            id
            productID
            serial
            name
            code
            size
            color
            material
            value
            remark
            mainPic
            customerID
            remain
            inventory
            publish
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        files {
          items {
            id
            productID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        publish
        createdAt
        updatedAt
        __typename
      }
      serial
      name
      code
      size
      color
      material
      value
      remark
      mainPic
      customerID
      remain
      inventory
      publish
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateModel = /* GraphQL */ `
  mutation UpdateModel(
    $input: UpdateModelInput!
    $condition: ModelModelConditionInput
  ) {
    updateModel(input: $input, condition: $condition) {
      id
      productID
      product {
        id
        category
        name
        mainTitle
        subTitle
        mainPic
        models {
          items {
            id
            productID
            serial
            name
            code
            size
            color
            material
            value
            remark
            mainPic
            customerID
            remain
            inventory
            publish
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        files {
          items {
            id
            productID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        publish
        createdAt
        updatedAt
        __typename
      }
      serial
      name
      code
      size
      color
      material
      value
      remark
      mainPic
      customerID
      remain
      inventory
      publish
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteModel = /* GraphQL */ `
  mutation DeleteModel(
    $input: DeleteModelInput!
    $condition: ModelModelConditionInput
  ) {
    deleteModel(input: $input, condition: $condition) {
      id
      productID
      product {
        id
        category
        name
        mainTitle
        subTitle
        mainPic
        models {
          items {
            id
            productID
            serial
            name
            code
            size
            color
            material
            value
            remark
            mainPic
            customerID
            remain
            inventory
            publish
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        files {
          items {
            id
            productID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        publish
        createdAt
        updatedAt
        __typename
      }
      serial
      name
      code
      size
      color
      material
      value
      remark
      mainPic
      customerID
      remain
      inventory
      publish
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSubModel = /* GraphQL */ `
  mutation CreateSubModel(
    $input: CreateSubModelInput!
    $condition: ModelSubModelConditionInput
  ) {
    createSubModel(input: $input, condition: $condition) {
      id
      modelID
      model {
        id
        productID
        product {
          id
          category
          name
          mainTitle
          subTitle
          mainPic
          models {
            nextToken
            __typename
          }
          files {
            nextToken
            __typename
          }
          publish
          createdAt
          updatedAt
          __typename
        }
        serial
        name
        code
        size
        color
        material
        value
        remark
        mainPic
        customerID
        remain
        inventory
        publish
        createdAt
        updatedAt
        __typename
      }
      customerID
      customer {
        id
        email
        passwd
        serial
        name
        office
        post
        pref
        address
        build
        tel
        fax
        url
        agencyID
        closing
        payment
        rate
        charge
        salesID
        color
        createdAt
        updatedAt
        __typename
      }
      name
      code
      value
      enabled
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSubModel = /* GraphQL */ `
  mutation UpdateSubModel(
    $input: UpdateSubModelInput!
    $condition: ModelSubModelConditionInput
  ) {
    updateSubModel(input: $input, condition: $condition) {
      id
      modelID
      model {
        id
        productID
        product {
          id
          category
          name
          mainTitle
          subTitle
          mainPic
          models {
            nextToken
            __typename
          }
          files {
            nextToken
            __typename
          }
          publish
          createdAt
          updatedAt
          __typename
        }
        serial
        name
        code
        size
        color
        material
        value
        remark
        mainPic
        customerID
        remain
        inventory
        publish
        createdAt
        updatedAt
        __typename
      }
      customerID
      customer {
        id
        email
        passwd
        serial
        name
        office
        post
        pref
        address
        build
        tel
        fax
        url
        agencyID
        closing
        payment
        rate
        charge
        salesID
        color
        createdAt
        updatedAt
        __typename
      }
      name
      code
      value
      enabled
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSubModel = /* GraphQL */ `
  mutation DeleteSubModel(
    $input: DeleteSubModelInput!
    $condition: ModelSubModelConditionInput
  ) {
    deleteSubModel(input: $input, condition: $condition) {
      id
      modelID
      model {
        id
        productID
        product {
          id
          category
          name
          mainTitle
          subTitle
          mainPic
          models {
            nextToken
            __typename
          }
          files {
            nextToken
            __typename
          }
          publish
          createdAt
          updatedAt
          __typename
        }
        serial
        name
        code
        size
        color
        material
        value
        remark
        mainPic
        customerID
        remain
        inventory
        publish
        createdAt
        updatedAt
        __typename
      }
      customerID
      customer {
        id
        email
        passwd
        serial
        name
        office
        post
        pref
        address
        build
        tel
        fax
        url
        agencyID
        closing
        payment
        rate
        charge
        salesID
        color
        createdAt
        updatedAt
        __typename
      }
      name
      code
      value
      enabled
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createFile = /* GraphQL */ `
  mutation CreateFile(
    $input: CreateFileInput!
    $condition: ModelFileConditionInput
  ) {
    createFile(input: $input, condition: $condition) {
      id
      productID
      product {
        id
        category
        name
        mainTitle
        subTitle
        mainPic
        models {
          items {
            id
            productID
            serial
            name
            code
            size
            color
            material
            value
            remark
            mainPic
            customerID
            remain
            inventory
            publish
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        files {
          items {
            id
            productID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        publish
        createdAt
        updatedAt
        __typename
      }
      name
      file
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateFile = /* GraphQL */ `
  mutation UpdateFile(
    $input: UpdateFileInput!
    $condition: ModelFileConditionInput
  ) {
    updateFile(input: $input, condition: $condition) {
      id
      productID
      product {
        id
        category
        name
        mainTitle
        subTitle
        mainPic
        models {
          items {
            id
            productID
            serial
            name
            code
            size
            color
            material
            value
            remark
            mainPic
            customerID
            remain
            inventory
            publish
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        files {
          items {
            id
            productID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        publish
        createdAt
        updatedAt
        __typename
      }
      name
      file
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteFile = /* GraphQL */ `
  mutation DeleteFile(
    $input: DeleteFileInput!
    $condition: ModelFileConditionInput
  ) {
    deleteFile(input: $input, condition: $condition) {
      id
      productID
      product {
        id
        category
        name
        mainTitle
        subTitle
        mainPic
        models {
          items {
            id
            productID
            serial
            name
            code
            size
            color
            material
            value
            remark
            mainPic
            customerID
            remain
            inventory
            publish
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        files {
          items {
            id
            productID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        publish
        createdAt
        updatedAt
        __typename
      }
      name
      file
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createOrder = /* GraphQL */ `
  mutation CreateOrder(
    $input: CreateOrderInput!
    $condition: ModelOrderConditionInput
  ) {
    createOrder(input: $input, condition: $condition) {
      id
      corporateID
      customerID
      customer {
        id
        email
        passwd
        serial
        name
        office
        post
        pref
        address
        build
        tel
        fax
        url
        agencyID
        closing
        payment
        rate
        charge
        salesID
        color
        createdAt
        updatedAt
        __typename
      }
      projectID
      agencyID
      amount
      tax
      payment
      complete
      publish
      status
      transactionID
      transactionDate
      processID
      processPass
      createdAt
      estimateDate
      estimateLimit
      orderDate
      claimDate
      fixedDate
      paymentDate
      paymentTerms
      deliveryDate
      title
      remarks
      officeID
      chargeID
      orderItems {
        items {
          id
          orderID
          order {
            id
            corporateID
            customerID
            projectID
            agencyID
            amount
            tax
            payment
            complete
            publish
            status
            transactionID
            transactionDate
            processID
            processPass
            createdAt
            estimateDate
            estimateLimit
            orderDate
            claimDate
            fixedDate
            paymentDate
            paymentTerms
            deliveryDate
            title
            remarks
            officeID
            chargeID
            updatedAt
            __typename
          }
          modelID
          subModelID
          name
          quantity
          unit
          value
          remarks
          sort
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const updateOrder = /* GraphQL */ `
  mutation UpdateOrder(
    $input: UpdateOrderInput!
    $condition: ModelOrderConditionInput
  ) {
    updateOrder(input: $input, condition: $condition) {
      id
      corporateID
      customerID
      customer {
        id
        email
        passwd
        serial
        name
        office
        post
        pref
        address
        build
        tel
        fax
        url
        agencyID
        closing
        payment
        rate
        charge
        salesID
        color
        createdAt
        updatedAt
        __typename
      }
      projectID
      agencyID
      amount
      tax
      payment
      complete
      publish
      status
      transactionID
      transactionDate
      processID
      processPass
      createdAt
      estimateDate
      estimateLimit
      orderDate
      claimDate
      fixedDate
      paymentDate
      paymentTerms
      deliveryDate
      title
      remarks
      officeID
      chargeID
      orderItems {
        items {
          id
          orderID
          order {
            id
            corporateID
            customerID
            projectID
            agencyID
            amount
            tax
            payment
            complete
            publish
            status
            transactionID
            transactionDate
            processID
            processPass
            createdAt
            estimateDate
            estimateLimit
            orderDate
            claimDate
            fixedDate
            paymentDate
            paymentTerms
            deliveryDate
            title
            remarks
            officeID
            chargeID
            updatedAt
            __typename
          }
          modelID
          subModelID
          name
          quantity
          unit
          value
          remarks
          sort
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const deleteOrder = /* GraphQL */ `
  mutation DeleteOrder(
    $input: DeleteOrderInput!
    $condition: ModelOrderConditionInput
  ) {
    deleteOrder(input: $input, condition: $condition) {
      id
      corporateID
      customerID
      customer {
        id
        email
        passwd
        serial
        name
        office
        post
        pref
        address
        build
        tel
        fax
        url
        agencyID
        closing
        payment
        rate
        charge
        salesID
        color
        createdAt
        updatedAt
        __typename
      }
      projectID
      agencyID
      amount
      tax
      payment
      complete
      publish
      status
      transactionID
      transactionDate
      processID
      processPass
      createdAt
      estimateDate
      estimateLimit
      orderDate
      claimDate
      fixedDate
      paymentDate
      paymentTerms
      deliveryDate
      title
      remarks
      officeID
      chargeID
      orderItems {
        items {
          id
          orderID
          order {
            id
            corporateID
            customerID
            projectID
            agencyID
            amount
            tax
            payment
            complete
            publish
            status
            transactionID
            transactionDate
            processID
            processPass
            createdAt
            estimateDate
            estimateLimit
            orderDate
            claimDate
            fixedDate
            paymentDate
            paymentTerms
            deliveryDate
            title
            remarks
            officeID
            chargeID
            updatedAt
            __typename
          }
          modelID
          subModelID
          name
          quantity
          unit
          value
          remarks
          sort
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const createOrderItem = /* GraphQL */ `
  mutation CreateOrderItem(
    $input: CreateOrderItemInput!
    $condition: ModelOrderItemConditionInput
  ) {
    createOrderItem(input: $input, condition: $condition) {
      id
      orderID
      order {
        id
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        projectID
        agencyID
        amount
        tax
        payment
        complete
        publish
        status
        transactionID
        transactionDate
        processID
        processPass
        createdAt
        estimateDate
        estimateLimit
        orderDate
        claimDate
        fixedDate
        paymentDate
        paymentTerms
        deliveryDate
        title
        remarks
        officeID
        chargeID
        orderItems {
          items {
            id
            orderID
            modelID
            subModelID
            name
            quantity
            unit
            value
            remarks
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      modelID
      subModelID
      name
      quantity
      unit
      value
      remarks
      sort
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateOrderItem = /* GraphQL */ `
  mutation UpdateOrderItem(
    $input: UpdateOrderItemInput!
    $condition: ModelOrderItemConditionInput
  ) {
    updateOrderItem(input: $input, condition: $condition) {
      id
      orderID
      order {
        id
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        projectID
        agencyID
        amount
        tax
        payment
        complete
        publish
        status
        transactionID
        transactionDate
        processID
        processPass
        createdAt
        estimateDate
        estimateLimit
        orderDate
        claimDate
        fixedDate
        paymentDate
        paymentTerms
        deliveryDate
        title
        remarks
        officeID
        chargeID
        orderItems {
          items {
            id
            orderID
            modelID
            subModelID
            name
            quantity
            unit
            value
            remarks
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      modelID
      subModelID
      name
      quantity
      unit
      value
      remarks
      sort
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteOrderItem = /* GraphQL */ `
  mutation DeleteOrderItem(
    $input: DeleteOrderItemInput!
    $condition: ModelOrderItemConditionInput
  ) {
    deleteOrderItem(input: $input, condition: $condition) {
      id
      orderID
      order {
        id
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        projectID
        agencyID
        amount
        tax
        payment
        complete
        publish
        status
        transactionID
        transactionDate
        processID
        processPass
        createdAt
        estimateDate
        estimateLimit
        orderDate
        claimDate
        fixedDate
        paymentDate
        paymentTerms
        deliveryDate
        title
        remarks
        officeID
        chargeID
        orderItems {
          items {
            id
            orderID
            modelID
            subModelID
            name
            quantity
            unit
            value
            remarks
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      modelID
      subModelID
      name
      quantity
      unit
      value
      remarks
      sort
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createStock = /* GraphQL */ `
  mutation CreateStock(
    $input: CreateStockInput!
    $condition: ModelStockConditionInput
  ) {
    createStock(input: $input, condition: $condition) {
      id
      userID
      customerID
      modelID
      quantity
      total
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateStock = /* GraphQL */ `
  mutation UpdateStock(
    $input: UpdateStockInput!
    $condition: ModelStockConditionInput
  ) {
    updateStock(input: $input, condition: $condition) {
      id
      userID
      customerID
      modelID
      quantity
      total
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteStock = /* GraphQL */ `
  mutation DeleteStock(
    $input: DeleteStockInput!
    $condition: ModelStockConditionInput
  ) {
    deleteStock(input: $input, condition: $condition) {
      id
      userID
      customerID
      modelID
      quantity
      total
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPaymentDoc = /* GraphQL */ `
  mutation CreatePaymentDoc(
    $input: CreatePaymentDocInput!
    $condition: ModelPaymentDocConditionInput
  ) {
    createPaymentDoc(input: $input, condition: $condition) {
      id
      corporateID
      pic
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePaymentDoc = /* GraphQL */ `
  mutation UpdatePaymentDoc(
    $input: UpdatePaymentDocInput!
    $condition: ModelPaymentDocConditionInput
  ) {
    updatePaymentDoc(input: $input, condition: $condition) {
      id
      corporateID
      pic
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePaymentDoc = /* GraphQL */ `
  mutation DeletePaymentDoc(
    $input: DeletePaymentDocInput!
    $condition: ModelPaymentDocConditionInput
  ) {
    deletePaymentDoc(input: $input, condition: $condition) {
      id
      corporateID
      pic
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPayment = /* GraphQL */ `
  mutation CreatePayment(
    $input: CreatePaymentInput!
    $condition: ModelPaymentConditionInput
  ) {
    createPayment(input: $input, condition: $condition) {
      id
      no
      title
      kind
      corporateID
      customerID
      customer {
        id
        email
        passwd
        serial
        name
        office
        post
        pref
        address
        build
        tel
        fax
        url
        agencyID
        closing
        payment
        rate
        charge
        salesID
        color
        createdAt
        updatedAt
        __typename
      }
      orderDate
      claimDate
      fixedDate
      paymentDate
      amount
      tax
      payment
      commission
      complete
      pic
      remarks
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePayment = /* GraphQL */ `
  mutation UpdatePayment(
    $input: UpdatePaymentInput!
    $condition: ModelPaymentConditionInput
  ) {
    updatePayment(input: $input, condition: $condition) {
      id
      no
      title
      kind
      corporateID
      customerID
      customer {
        id
        email
        passwd
        serial
        name
        office
        post
        pref
        address
        build
        tel
        fax
        url
        agencyID
        closing
        payment
        rate
        charge
        salesID
        color
        createdAt
        updatedAt
        __typename
      }
      orderDate
      claimDate
      fixedDate
      paymentDate
      amount
      tax
      payment
      commission
      complete
      pic
      remarks
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePayment = /* GraphQL */ `
  mutation DeletePayment(
    $input: DeletePaymentInput!
    $condition: ModelPaymentConditionInput
  ) {
    deletePayment(input: $input, condition: $condition) {
      id
      no
      title
      kind
      corporateID
      customerID
      customer {
        id
        email
        passwd
        serial
        name
        office
        post
        pref
        address
        build
        tel
        fax
        url
        agencyID
        closing
        payment
        rate
        charge
        salesID
        color
        createdAt
        updatedAt
        __typename
      }
      orderDate
      claimDate
      fixedDate
      paymentDate
      amount
      tax
      payment
      commission
      complete
      pic
      remarks
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPaymentItem = /* GraphQL */ `
  mutation CreatePaymentItem(
    $input: CreatePaymentItemInput!
    $condition: ModelPaymentItemConditionInput
  ) {
    createPaymentItem(input: $input, condition: $condition) {
      id
      paymentID
      payment {
        id
        no
        title
        kind
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        orderDate
        claimDate
        fixedDate
        paymentDate
        amount
        tax
        payment
        commission
        complete
        pic
        remarks
        createdAt
        updatedAt
        __typename
      }
      modelID
      subModelID
      name
      quantity
      unit
      value
      remarks
      sort
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePaymentItem = /* GraphQL */ `
  mutation UpdatePaymentItem(
    $input: UpdatePaymentItemInput!
    $condition: ModelPaymentItemConditionInput
  ) {
    updatePaymentItem(input: $input, condition: $condition) {
      id
      paymentID
      payment {
        id
        no
        title
        kind
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        orderDate
        claimDate
        fixedDate
        paymentDate
        amount
        tax
        payment
        commission
        complete
        pic
        remarks
        createdAt
        updatedAt
        __typename
      }
      modelID
      subModelID
      name
      quantity
      unit
      value
      remarks
      sort
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePaymentItem = /* GraphQL */ `
  mutation DeletePaymentItem(
    $input: DeletePaymentItemInput!
    $condition: ModelPaymentItemConditionInput
  ) {
    deletePaymentItem(input: $input, condition: $condition) {
      id
      paymentID
      payment {
        id
        no
        title
        kind
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        orderDate
        claimDate
        fixedDate
        paymentDate
        amount
        tax
        payment
        commission
        complete
        pic
        remarks
        createdAt
        updatedAt
        __typename
      }
      modelID
      subModelID
      name
      quantity
      unit
      value
      remarks
      sort
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createFacility = /* GraphQL */ `
  mutation CreateFacility(
    $input: CreateFacilityInput!
    $condition: ModelFacilityConditionInput
  ) {
    createFacility(input: $input, condition: $condition) {
      id
      group
      name
      type
      enableWeek
      enableTime
      enableFewMonth
      minMinutes
      publish
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateFacility = /* GraphQL */ `
  mutation UpdateFacility(
    $input: UpdateFacilityInput!
    $condition: ModelFacilityConditionInput
  ) {
    updateFacility(input: $input, condition: $condition) {
      id
      group
      name
      type
      enableWeek
      enableTime
      enableFewMonth
      minMinutes
      publish
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteFacility = /* GraphQL */ `
  mutation DeleteFacility(
    $input: DeleteFacilityInput!
    $condition: ModelFacilityConditionInput
  ) {
    deleteFacility(input: $input, condition: $condition) {
      id
      group
      name
      type
      enableWeek
      enableTime
      enableFewMonth
      minMinutes
      publish
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createFacilityReserve = /* GraphQL */ `
  mutation CreateFacilityReserve(
    $input: CreateFacilityReserveInput!
    $condition: ModelFacilityReserveConditionInput
  ) {
    createFacilityReserve(input: $input, condition: $condition) {
      id
      facilityID
      customerID
      name
      start
      end
      color
      remarks
      charge
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateFacilityReserve = /* GraphQL */ `
  mutation UpdateFacilityReserve(
    $input: UpdateFacilityReserveInput!
    $condition: ModelFacilityReserveConditionInput
  ) {
    updateFacilityReserve(input: $input, condition: $condition) {
      id
      facilityID
      customerID
      name
      start
      end
      color
      remarks
      charge
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteFacilityReserve = /* GraphQL */ `
  mutation DeleteFacilityReserve(
    $input: DeleteFacilityReserveInput!
    $condition: ModelFacilityReserveConditionInput
  ) {
    deleteFacilityReserve(input: $input, condition: $condition) {
      id
      facilityID
      customerID
      name
      start
      end
      color
      remarks
      charge
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAttendance = /* GraphQL */ `
  mutation CreateAttendance(
    $input: CreateAttendanceInput!
    $condition: ModelAttendanceConditionInput
  ) {
    createAttendance(input: $input, condition: $condition) {
      id
      userID
      temperature
      mask
      alcohol
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateAttendance = /* GraphQL */ `
  mutation UpdateAttendance(
    $input: UpdateAttendanceInput!
    $condition: ModelAttendanceConditionInput
  ) {
    updateAttendance(input: $input, condition: $condition) {
      id
      userID
      temperature
      mask
      alcohol
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteAttendance = /* GraphQL */ `
  mutation DeleteAttendance(
    $input: DeleteAttendanceInput!
    $condition: ModelAttendanceConditionInput
  ) {
    deleteAttendance(input: $input, condition: $condition) {
      id
      userID
      temperature
      mask
      alcohol
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createLog = /* GraphQL */ `
  mutation CreateLog(
    $input: CreateLogInput!
    $condition: ModelLogConditionInput
  ) {
    createLog(input: $input, condition: $condition) {
      id
      userID
      customerID
      type
      text
      createdAt
      ttl
      updatedAt
      __typename
    }
  }
`;
export const updateLog = /* GraphQL */ `
  mutation UpdateLog(
    $input: UpdateLogInput!
    $condition: ModelLogConditionInput
  ) {
    updateLog(input: $input, condition: $condition) {
      id
      userID
      customerID
      type
      text
      createdAt
      ttl
      updatedAt
      __typename
    }
  }
`;
export const deleteLog = /* GraphQL */ `
  mutation DeleteLog(
    $input: DeleteLogInput!
    $condition: ModelLogConditionInput
  ) {
    deleteLog(input: $input, condition: $condition) {
      id
      userID
      customerID
      type
      text
      createdAt
      ttl
      updatedAt
      __typename
    }
  }
`;
